import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export function Breadcrumbs(props) {
  var entries = props.entries,
    className = props.className,
    hideOnMobile = props.hideOnMobile;
  if (entries instanceof Array === false) return null;
  return /*#__PURE__*/React.createElement("ul", {
    className: cx('list', className, {
      hideOnMobile: hideOnMobile
    }),
    itemScope: true,
    itemType: "http://schema.org/BreadcrumbList"
  }, entries.map(function (entry, index) {
    if (entry.url) {
      return /*#__PURE__*/React.createElement("li", {
        className: cx('item'),
        itemProp: "itemListElement",
        itemScope: true,
        itemType: "http://schema.org/ListItem",
        key: index
      }, /*#__PURE__*/React.createElement("a", {
        className: cx('link'),
        href: entry.url,
        itemProp: "item"
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: entry.title
        },
        itemProp: "name"
      })), /*#__PURE__*/React.createElement("meta", {
        content: index + 1,
        itemProp: "position"
      }));
    }
    return /*#__PURE__*/React.createElement("li", {
      className: cx('item'),
      dangerouslySetInnerHTML: {
        __html: entry.title
      },
      key: index
    });
  }));
}

/**
 * @deprecated, should not provide wrapper, use `Breadcrumbs` with project specific wrapper
 * kept for backward compatibility, adds 1040px wrapper and indent to component
 */
export default function BreadcrumbsFloor(_ref) {
  var className = _ref.className,
    inheritedProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Breadcrumbs, _extends({}, inheritedProps, {
    className: ['wrapper', className]
  }));
}
Breadcrumbs.propTypes = process.env.NODE_ENV !== "production" ? {
  entries: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string
  })).isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  hideOnMobile: PropTypes.bool
} : {};
BreadcrumbsFloor.propTypes = process.env.NODE_ENV !== "production" ? Breadcrumbs.propTypes : {};